import React from 'react';
import { Box } from '@mui/material';
import { styled, keyframes } from '@mui/system';

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
`;

const Bubble = styled(Box)(({ theme, position="left" }) => ({
  backgroundColor: theme.palette.shades['clr-grey-100'],
  color: '#555',
  padding: theme.spacing(1.5, 2),
  borderRadius: '12px',
  borderBottomLeftRadius: position==='left' ? '2px' : '12px',
  borderBottomRightRadius: position!=='left' ? '2px' : '12px',
  maxWidth: '200px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const DotContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: '24px',
  width: '36px',
  gap: 6,
});

const Dot = styled(Box)(({ theme, delay }) => ({
  width: 6,
  height: 6,
  borderRadius: '50%',
  backgroundColor: theme.palette.neutral['clr-400'],
  animation: `${bounce} 1.4s infinite ease-in-out`,
  animationDelay: delay,
}));

const MessageIndicator = ({ position='left' }) => {
  return (
    <Box display="flex" justifyContent="flex-start" padding={1}>
      <Bubble position={position}>
        <DotContainer>
          <Dot delay="0ms" />
          <Dot delay="150ms" />
          <Dot delay="300ms" />
        </DotContainer>
      </Bubble>
    </Box>
  );
};

export default MessageIndicator;
